<template>
	<span class="dev-version" style="display: none">core {{ config.version }}, build {{ buildVersion ? buildVersion : 0 }}</span>
</template>

<script setup>
	const config = useAppConfig();
	const buildVersion = ref(import.meta.env.VITE_BUILD_VERSION);
</script>
